export const Dictionaries = {
  TemporaryCarAction: {
    1: '南门进区',
    2: '南门出区',
    3: '西门进区',
    4: '西门出区'
  },
  NotificationType: {
    1: '便捷出入区申请'
  },
  shelf_life_unit: {
    1: '天',
    2: '月',
    3: '年'
  },
  wxcodeStatus: {
    1: '上传中',
    2: '上传失败',
    3: '待审核',
    4: '审核中',
    5: '审核失败',
    6: '审核成功',
    7: '审核延后'

  },
  commodity_purchase_status: {
    1: '创建',
    2: '接收',
    3: '上架'
  },
  trans_mode: {
    '0': '非保税区',
    '1': '监管仓库',
    '2': '水路运输',
    '3': '铁路运输',
    '4': '公路运输',
    '5': '航空运输',
    '6': '邮件运输',
    '7': '保税区',
    '8': '保税仓库',
    '9': '其它运输',
    'A': '全部运输方式',
    'H': '边境特殊海关作业区',
    'W': '物流中心',
    'X': '物流园区',
    'Y': '保税港区',
    'Z': '出口加工区'
  },
  pick_status: {
    1: '未指定',
    2: '已指定',
    3: '已分拣',
    4: '已打包',
    5: '已完成'
    // 5: '海关审查中',
    // 7: '已拦截',
    // 8: '已取消',
    // 9: '一般商品已发货'
  },
  logistics_company: {
    1: '未知',
    2: '圆通'
  },
  outflow_status: {
    1: '创建',
    2: '完成',
    3: '取消'
  },
  wechat_order_status: {
    1: '创建',
    2: '同步',
    3: '完成',
    4: '失败'
  },
  transfer_inventory_status: {
    1: '创建',
    2: '出库',
    3: '入库'
  },
  intercept_order_status: {
    1: '创建',
    2: '完成',
    3: '拦截失败'
  },
  status: [
    { 1: '待入园' },
    { 2: '已入园' },
    { 3: '已注销' }
  ],
  RecordAction: {
    1: '创建',
    2: '删除'
  },
  CorporationLocation: {
    1: '北',
    2: '南'
  },
  GoodsType: {
    1: '一般商品',
    2: '跨境电商',
    3: '以上两者'
  },
  mallshop_order_status: {
    1: '待支付',
    2: '待发货',
    3: '待收货',
    4: '待评价',
    5: '已取消',
    6: '系统取消',
    7: '退款中',
    8: '已退款',
    9: '已支付，库存不足'
  },
  location: [
    { 1: '北区' },
    { 2: '南区' },
    { 3: '其他' }
  ],
  rolesObj: {
    1: '管理端',
    2: '企业端',
    3: '物业端',
    4: '协管端'
  },
  roles: [
    { 1: '管理员' },
    { 2: '企业' },
    { 3: '物业' },
    { 4: '协管' }
  ],
  ContractStatus: {
    1: '已创建',
    2: '已签约',
    3: '已废除',
    4: '已完成'
  },
  BillStatus: {
    1: '待支付',
    2: '已支付',
    3: '已取消',
    4: '已完成',
    6: '未生成审批',
    7: '审批中',
    8: '审批失败'
  },
  BillCreateMode: {
    1: '自动',
    2: '按时间',
    3: '手动',
    4: '减免'
  },
  BillSearchStatus: {
    1: '待支付',
    2: '已支付',
    3: '已取消'
  },
  PaymentTicketStatus: {
    1: '未审核',
    2: '已审核',
    3: '申请发票',
    4: '已完成',
    5: '已拒绝'
  },
  PaymentTicketCategory: {
    1: '物业',
    2: '租金',
    3: '水费',
    4: '电费',
    5: '预付电费',
    6: '保证金',
    10: '系统生成',
    11: '手工生成'
  },
  FapiaoApplicationStatus: {
    1: '待审核',
    2: '已同意',
    3: '已拒绝'
  },
  take_inventory_method: {
    1: '公司盘存',
    2: '仓库盘存'
  },
  take_inventory_status: {
    1: '待确认',
    2: '已确认',
    3: '已取消'
  },
  rent_contract: [
    { en_name: 'corporation', name: '公司' },
    { en_name: 'start_date', name: '开始时间' },
    { en_name: 'end_date', name: '结束时间' },
    { en_name: 'deposit', name: '押金' },
    { en_name: 'year_increase', name: '年增长百分比' },
    { en_name: 'number', name: '合同编号' },
    { en_name: 'address', name: '企业注册地址' },
    { en_name: 'rent_address', name: '企业租赁地址' },
    { en_name: 'in_charge_person', name: '负责人' },
    { en_name: 'contact_person', name: '乙方联系人' },
    { en_name: 'contact_phone', name: '乙方联系人电话' },
    { en_name: 'a_contact_person', name: '甲方联系人' },
    { en_name: 'a_contact_phone', name: '甲方联系人电话' }
  ],
  GateWayStatus: {
    1: '已创建',
    2: '已核准',
    3: '已进区',
    4: '已出区',
    5: '已取消'
  },
  GateWayItem: [
    {
      key: 1,
      label: '固定资产类',
      value: 1,
      children: [
        {
          label: '仪器、工具、机器/设备',
          value: 1,
          key: 1
        },
        {
          label: '办公类',
          value: 2,
          key: 2
        }
      ]
    },
    {
      key: 2,
      value: 2,
      label: '消耗品类',
      children: [
        {
          label: '自用办公耗材',
          value: 11,
          key: 11
        },
        {
          label: '生产用物料',
          value: 12,
          key: 12
        },
        {
          label: '劳保',
          value: 13,
          key: 13
        },
        {
          label: '生活消费',
          value: 14,
          key: 14
        }
      ]
    },
    {
      key: 3,
      value: 3,
      label: '基建设备物品类',
      children: [
        {
          label: '机器',
          value: 21,
          key: 21
        },
        {
          label: '设备',
          value: 22,
          key: 22
        },
        {
          label: '物资',
          value: 23,
          key: 23
        }
      ]
    },
    {
      key: 4,
      value: 4,
      label: '其他',
      children: [
        {
          label: '其他',
          value: 31,
          key: 31
        }
      ]
    }
  ],
  Category: {
    1: '固定资产类',
    2: '消耗品类',
    3: '基建设备物品类',
    4: '其他',
    5: '渣土'
  },
  Subcategory: {
    1: '仪器、工具、机器/设备',
    2: '办公类',
    11: '自用办公耗材',
    12: '生产用物料',
    13: '劳保',
    14: '生活消费',
    21: '机器',
    22: '设备',
    23: '物资',
    31: '其他',
    41: '渣土'
  },
  returnCode: {
    1000: '成功请求并返回数据',
    2000: '参数不足',
    2001: '参数验证失败',
    3000: '数据异常',
    4000: '对象不存在',
    4001: '用户名重复',
    4002: '用户名或密码错误',
    4003: '状态错误',
    4004: '有子资源',
    4005: '数据重复',
    4006: '获取微信 openid 错误',
    4007: '解密数据失败',
    4008: '第三方服务错误',
    4009: '密码错误',
    4010: '账单已存在',
    4011: '配置项没有打开',
    4012: '库存不足',
    4013: '数量限制',
    4014: '记录存在',
    4015: '微信错误',
    4016: '微信凭证错误',
    4017: '展示商品金额错误',
    4018: '展示商品退回路径错误',
    4019: '商品计算库存错误',
    4020: '商品重复退款',
    4021: '等待浪潮审批',
    4022: '浪潮驳回'
  },
  property_owner: {
    // 1: '自持',
    // 2: '代理'
    1: '自营',
    2: '管委会',
    3: '济高'
  },
  account_owner: {
    1: '自营',
    2: '管委会',
    3: '济高',
    4: '保证金'
  },
  property_owner_account: {
    1: '86611778101421004588',
    2: '86611778101421004571',
    3: '86611029101421026547',
    4: '86611731101421004169'
  },
  property_type: {
    1: '工厂',
    2: '土地',
    3: '仓库',
    4: '办公',
    5: '厂房配套办公'
  },
  unit: {},
  country: {},
  currency: {},
  CustomsPaymentCheckStatus: {
    1: '已创建',
    2: '已完成',
    3: '失败'
  },
  is_pushed: {
    0: '已推送',
    1: '未推送'
  },
  is_auto_pushed: {
    1: '是',
    0: '否'
  },
  can_pushed: {
    1: '是',
    0: '否'
  },
  is_union: {
    true: '是',
    false: '否'
  },
  order_return_status: {
    '1': '电子口岸已暂存',
    '2': '电子口岸申报中',
    '3': '发送海关成功',
    '4': '发送海关失败',
    '100': '海关退单',
    '120': '海关入库',
    '300': '人工审核',
    '399': '海关审结',
    '800': '放行',
    '899': '结关',
    '500': '查验',
    '501': '扣留移送通关',
    '502': '扣留移送缉私',
    '503': '扣留移送法规',
    '599': '其它扣留',
    '700': '退运'
  },
  locations: {
    'north': '北区',
    'south': '南区',
    'other': '其他'
  },
  locations_type: {
    'factory': '厂房',
    'office': '办公室',
    'land': '地皮',
    'warehouse': '仓库'
  },
  electricity_meter_property_owner: {
    1: '自营',
    2: '管委会',
    3: '济高'
  },
  applet_order_status: {
    1: '待付款',
    2: '待发货',
    3: '已发货',
    4: '已收货',
    5: '已取消',
    6: '系统取消',
    7: '退款中',
    8: '退款完成',
    11: '部分退款'
  },
  delivery_method: {
    1: '快递',
    2: '自提'
  },
  declaration_status: {
    1: '未申报',
    2: '检查中',
    3: '已通过'
  },
  pick_list_order_source: {
    1: '微信',
    2: '柜台'
  },
  applet_order_exam_status_text: {
    2: '待审核',
    3: '通过',
    4: '驳回'
  },
  applet_order_exam_status: {
    3: '通过',
    4: '驳回'
  },
  refund_order_exam_status: {
    3: '通过',
    4: '驳回'
  },
  goods_type: {
    1: '一般商品',
    2: '跨境商品'
  },
  integrity_refund_goods: {
    2: '校验商品完整性',
    3: '完好',
    4: '不完好'
  },
  refund_goods_status: {
    1: '未处理',
    2: '已处理'
  },
  order_source: {
    1: '线上',
    2: '线下'
  },
  open_consumption_tax: {
    1: '关闭',
    2: '开启'
  },
  consumption_tax_unit: {
    1: '法定单位1',
    2: '法定单位2'
  },
  property_project_check_status: {
    1: '创建',
    2: '审批中',
    3: '完成',
    4: '失败'
  },
  property_project_category: {
    1: '用印',
    2: '付款',
    3: '报销',
    4: '冲销'
  },
  property_project_fee_category: {
    1: '员工',
    2: '供应商'
  },
  property_project_fee_method: {
    1: '现金',
    2: '银行转账'
  },
  property_project_fee_type: {
    1: '物业费',
    2: '水费',
    3: '电费',
    4: '其他'
  },
  property_project_seal_type: [
    '公章',
    '法人名章',
    '合同章',
    '中英文章',
    '党支部章',
    '财务章',
    '提货专用章',
    '其它'
  ],
  property_project_fee_subject: {
    1: '物业公司服务费',
    2: '园区改造修理修缮',
    3: '园区日常运营支出',
    4: '园区电费支出',
    5: '园区用水支出',
    6: '其他'
  },
  business_type: {
    'water_bill': '水费账单',
    'electricity_bill': '电费账单',
    'rent_bill': '租金账单',
    'property_bill': '物业账单',
    'contract_bill': '合同',
    'guarantee_bill': '保证金账单'
  },
  approval_result_status: {
    0: '待审批',
    1: '已审批'
  },
  public_area_fee_type: {
    1: '水费',
    2: '电费'
  },
  approval_result: {
    1: '审批中',
    2: '通过',
    3: '驳回',
    4: '已推送金蝶'
  },
  coupon_category: {
    1: '全场通用',
    2: '商品分类',
    3: '商品'
  },
  duration_type: {
    1: '天',
    2: '截至日期'
  },
  refund_order_status: {
    1: '申请退款',
    2: '同意退款',
    3: '用户已发出商品',
    4: '完成退款',
    5: '拒绝退款',
    6: '退款失败'
  },
  goods_sell_type: {
    1: '自营',
    2: '代销'
  },
  value_card_status: {
    1: '已创建',
    2: '已销售',
    3: '已开票'
  },
  admin_permission_group: {
    'property': '资产',
    'finance': '财务',
    'user': '用户',
    'corporation': '企业',
    'tools': '工具',
    'data': '资料',
    'warehouse_shop': '仓库/门店',
    'oa': 'OA',
    'trade': '贸易',
    'monitor': '停机坪',
    'business_card': '电子名片',
    'null': '其他'
  },
  corporation_permission_group: {
    'in_out': '进出区管理',
    'contract': '合同',
    'bill': '账单',
    'finance': '财务',
    'basic': '基础',
    'user': '用户',
    'bonded': '保税',
    'show': '展示',
    'customs_declaration': '报关',
    'config': '配置',
    'null': '其他'
  },
  trade_payment_method: {
    1: '电汇',
    2: '银行承兑',
    3: '信用证',
    4: '商业承兑',
    5: '托收'
  },
  trade_cost_type: {
    1: '电汇',
    2: '银行承兑',
    3: '商业承兑',
    4: '福费廷',
    5: '押汇'
  },
  trade_fapiao_method: {
    1: '开票',
    2: '收票'
  },
  trade_approve_type: {
    'trade_sell_contract': '购销合同',
    'trade_customs_declaration_in': '报关信息-进口',
    'trade_customs_declaration_out': '报关信息-出口',
    'trade_contract': '普通合同',
    'trade_guarantee_contract': '担保合同',
    'trade_logistics': '物流信息',
    'trade_project_material': '资料',
    'trade_inventory': '出入库',
    'trade_inventory_adjustment': '出入库调整',
    'trade_payment': '付款',
    'trade_collection': '收款',
    'trade_fapiao': '发票',
    'trade_credit_letter': '信用证',
    'trade_credit_letter_repayment': '信用证还款',
    'trade_project_cost': '成本',
    'trade_settlement': '结算数量质量'
  },
  trade_material_type: {
    1: '货物',
    2: '物流',
    3: '资金',
    4: '其他'
  },
  trade_terms: [
    'FOB',
    'CIF',
    'CFR',
    'EXW',
    'FCA',
    'CPT',
    'CIP',
    'DAP',
    'DPU',
    'DDP',
    'FAS',
    'DDU',
    'DES'
  ],
  trade_types: {
    1: '内贸',
    2: '进口',
    3: '出口',
    4: '关前'
  },
  // 点价改为浮动定价，去掉浮动定价
  unit_price_type: {
    1: '固定定价',
    2: '浮动定价',
    // 3: '浮动定价',
    4: '无'
  },
  exchange_rate: {
    1: '固定汇率',
    2: '确定日期汇率',
    3: '其他日期汇率'
  },
  is_temp_unit_price: {
    0: '否',
    1: '临时美元单价',
    2: '临时人民币单价'
  },
  trade_pre_payment_method: {
    1: '电汇',
    2: '银行承兑',
    3: '信用证',
    4: '商业承兑',
    5: '托收'
  },
  trade_balance_payment_method: {
    1: '电汇',
    2: '银行承兑',
    3: '信用证',
    4: '商业承兑',
    5: '托收',
    6: '无'
  },
  trade_balance_payment_date_method: {
    1: '确定尾款日期',
    2: '承兑日后',
    3: '不确定尾款日期'
  },
  trade_inventory_type: {
    1: '入库',
    2: '出库',
    3: '平账'
  },
  trade_sell_contract_type: {
    1: '采购合同',
    2: '销售合同'
  },
  trade_contract_type: {
    1: '仓储合同',
    2: '货代合同',
    3: '租船合同',
    4: '订舱合同',
    5: '报关合同',
    6: '商检合同',
    7: '监装合同',
    8: '运输合同',
    9: '保险合同',
    10: '监管合同',
    11: '其他合同',
    12: '担保合同'
  },
  trade_inventory_goods_transfer_mode: {
    1: '先货后款',
    2: '先款后货'
  },
  trade_credit_letter_payment_method: {
    1: '信用证',
    2: '银行承兑汇票',
    3: '商业承兑汇票',
    4: '托收'
  },
  trade_payment_nature: {
    1: '预付货款',
    2: '关税',
    3: '消费税',
    4: '增值税',
    5: '结算尾款',
    6: '保险',
    7: '港口费用',
    8: '罐租费用',
    9: '货代费',
    10: '运输费',
    11: '开证费',
    12: '承兑费',
    13: '贴现费用',
    14: '审单费',
    15: '其他财务费用',
    16: '其他业务费用'
  },
  trade_contract_business_type: {
    1: '外采内销',
    2: '外采外销',
    3: '内采内销',
    4: '内采外销'
  },
  contractTypes: {
    1: '购销合同',
    2: '普通合同'
  },
  guarantee_method: {
    1: '保证',
    2: '抵押',
    3: '质押',
    4: '留置',
    5: '定金'
  },
  trade_value_compare_symbol: {
    1: '>',
    2: '<',
    3: '>=',
    4: '<=',
    5: '='
  },
  trade_product_default_value: {
    '石油焦': '水,硫,灰分,挥发分,发热量',
    '铁矿石': '铁,硫,磷,二氧化硅,氧化铝, 水',
    '原油': '密度（15℃）,密度（20℃）,硫,酸,残碳,按500℃总收益率',
    '燃料油': '密度（15℃）,密度（20℃）,硫,残碳,水分',
    '稀释沥青': '密度（15℃）,密度（20℃）,硫,360度蒸馏残余物,360度蒸馏残余物针入度'
  },
  is_has: {
    1: '是',
    0: '否'
  },
  trade_logistics_transport_way: {
    1: '船运',
    2: '汽运',
    3: '管道运输',
    4: '飞机运输',
    5: '火车运输',
    6: '自提'
  },
  dataModuleList: [
    {
      id: '1',
      name: '资产'
    },
    {
      id: '2',
      name: '贸易'
    }
],
  approval_category: [
    {
      key: 'trade',
      label: '贸易',
      value: 100,
      visible: true,
      children: [
        {
          label: '购销合同',
          value: 101,
          visible: true,
          key: 'trade_sell_contract'
        },
        {
          label: '普通合同',
          value: 102,
          visible: true,
          key: 'trade_contract',
          children: [
            {
              label: '仓储合同',
              value: 1020,
              visible: true,
              key: 'trade_storage_contract'
            },
            {
              label: '保险合同',
              value: 1021,
              visible: true,
              key: 'trade_insurance_contract'
            },
            {
              label: '租船合同',
              value: 1022,
              visible: true,
              key: 'trade_charter_party_contract'
            },
            {
              label: '订舱合同',
              value: 1023,
              visible: true,
              key: 'trade_booking_contract'
            },
            {
              label: '商检合同',
              value: 1024,
              visible: true,
              key: 'trade_inspection_contract'
            },
            {
              label: '货代合同',
              value: 1025,
              visible: true,
              key: 'trade_freight_forwarding_contract'
            },
            {
              label: '监装合同',
              value: 1026,
              visible: true,
              key: 'trade_loading_supervision_contract'
            },
            {
              label: '监管合同',
              value: 1027,
              visible: true,
              key: 'trade_supervision_contract'
            }
          ]
        },
        {
          label: '出入库',
          value: 103,
          visible: true,
          key: 'trade_inventory'
        },
        {
          label: '出入库调整',
          value: 104,
          visible: true,
          key: 'trade_inventory_adjustment'
        },
        {
          label: '付款',
          value: 105,
          visible: true,
          key: 'trade_payment'
        },
        {
          label: '收款',
          value: 106,
          visible: true,
          key: 'trade_collection'
        },
        {
          label: '发票',
          value: 107,
          visible: true,
          key: 'trade_fapiao'
        },
        {
          label: '信用证',
          value: 108,
          visible: true,
          key: 'trade_credit_letter'
        },
        {
          label: '信用证还款',
          value: 109,
          visible: true,
          key: 'trade_credit_letter_repayment'
        },
        {
          label: '担保合同',
          value: 110,
          visible: true,
          key: 'trade_guarantee_contract'
        },
        {
          label: '报关信息-进口',
          value: 111,
          visible: true,
          key: 'trade_customs_declaration_in'
        },
        {
          label: '报关信息-出口',
          value: 112,
          visible: true,
          key: 'trade_customs_declaration_out'
        },
        {
          label: '物流信息',
          value: 113,
          visible: true,
          key: 'trade_logistics'
        },
        {
          label: '成本',
          value: 114,
          visible: true,
          key: 'trade_cost'
        },
        {
          label: '结算数量质量',
          value: 115,
          visible: true,
          key: 'trade_settlement'
        },
        {
          label: '资料',
          value: 116,
          visible: true,
          key: 'trade_material'
        }
      ]
    },
    {
      key: 'bill',
      value: 200,
      label: '资产',
      visible: true,
      children: [
        {
          label: '水费账单',
          value: 201,
          visible: true,
          key: 'water_bill'
        },
        {
          label: '电费账单',
          value: 202,
          visible: true,
          key: 'electricity_bill'
        },
        {
          label: '租金账单',
          value: 203,
          visible: true,
          key: 'rent_bill'
        },
        {
          label: '物业账单',
          value: 204,
          visible: true,
          key: 'property_bill'
        },
        {
          label: '合同',
          value: 205,
          visible: true,
          key: 'contract_bill'
        },
        {
          label: '保证金账单',
          value: 206,
          visible: true,
          key: 'guarantee_bill'
        }
      ]
    },
    {
      key: 'other',
      value: 300,
      label: '其它',
      visible: true,
      children: [
        {
          label: '自定义',
          value: 301,
          visible: true,
          key: 'custom'
        }
      ]
    }
  ],
  monitor_plane_in_out_status: {
    0: '出',
    1: '入',
    2: '未知'
  },
  monitor_plane_pay_status: {
    0: '未缴费',
    1: '已缴费'
  },
  trade_file_type: {
    1: '合同附件',
    2: '发票及其他文件'
  },
  trade_collection_category: {
    1: '保证金',
    2: '预收款',
    3: '货款尾款'
  },
  trade_related_contract: [
    {
      value: 100,
      label: '购销合同',
      children: [
        {
          value: 101,
          label: '采购合同'
        },
        {
          value: 102,
          label: '销售合同'
        }
      ]
    },
    {
      value: 200,
      label: '普通合同',
      children: [
        {
          value: 201,
          label: '仓储合同'
        },
        {
          value: 202,
          label: '保险合同'
        },
        {
          value: 203,
          label: '租船合同'
        },
        {
          value: 204,
          label: '订舱合同'
        },
        {
          value: 205,
          label: '商检合同'
        },
        {
          value: 206,
          label: '货代合同'
        },
        {
          value: 207,
          label: '监装合同'
        },
        {
          value: 208,
          label: '监管合同'
        },
        {
          value: 209,
          label: '委托报关协议'
        },
        {
          value: 210,
          label: '资产评估委托合同'
        }
      ]
    }
  ],
  trade_inventory_loss_type: {
  1: '自然正常损耗',
  2: '人为损耗'
  },
  trade_client_types: {
    1: '贸易客户',
    2: '货运代理',
    3: '仓储公司',
    4: '保险公司',
    5: '船运公司',
    6: '商检公司',
    7: '监管公司',
    8: '陆运公司',
    9: '装卸搬运公司',
    10: '担保方',
    11: '贸易供应商'
  },
  trade_warehouse_stock_transfer_types: {
    1: '货转前提条件',
    2: '货转后约束条件'
  },
  trade_delivery_period_types: {
    1: '货转之后',
    2: '合同签订后',
    3: '押汇日后',
    4: '货物到港后',
    5: '入库后',
    6: '无'
  },
  trade_sell_contract_goods_transfer_prerequisites: {
    1: '合同签订后',
    2: '开证后',
    3: '预付款后',
    4: '付全款后',
    5: '船舶到港卸货后',
    6: '无'
  },
  trade_settlement_volume: {
    1: '提单',
    2: '卸船量',
    3: '入罐/入库量',
    4: '过磅量',
    5: '自定义结算量'
  },
  bank_services_types: {
    1: '进口信用证',
    2: '流动资金贷款',
    3: '银行承兑汇票',
    4: '国内信用证',
    5: '其他'
  },
  letter_credit_types: {
    1: '即期',
    2: '远期'
  },
  margin_resources: {
    1: '自有资金',
    2: '下游预付',
    3: '无'
  },
  trade_lc_types: {
    1: '即期押汇',
    2: '远期国际证',
    3: '即期国际证',
    4: '国内证'
  },
  trade_interest_deduction_method: {
    1: '按季',
    2: '按月',
    3: '利随本清'
  },
  trade_payment_application_reasons: {
    1: '保证金',
    2: '货款',
    3: '二次交单付款',
    4: '货款尾款'
  },
  trade_payment_application_reasons2: {
    1: '保证金',
    2: '预付款',
    3: '港杂费',
    4: '滞期费',
    5: '速遣费',
    6: '港口作业费',
    7: '货代费',
    8: '商检费',
    9: '保险费',
    10: '海运费',
    11: '陆运费',
    12: '监管费',
    13: '仓储及仓储费服务',
    14: '油污基金',
    15: '监装费',
    30: '其他'
  },
  trade_invoice_contract_type: {
    1: '销售合同',
    2: '服务合同',
    3: '其它'
  },
  trade_invoice_type: {
    1: '普通发票',
    2: '专用发票'
  },
  trade_bank_commercial_acceptance_type: {
    1: '银行承兑',
    2: '商业承兑'
  },
  trade_point_price_lock_type: {
    1: 'TAS',
    2: 'Trigger',
    3: '自然计价'
  },
  trade_contract_template_placeholders: [
    { en_name: 'contract_type_label', name: '合同类型' },
    { en_name: 'contract_number', name: '合同编号' },
    { en_name: 'delay_days', name: '延迟日期' }
  ],
  trade_contract_type_number: {
    'purchase_contract': '01',
    'sell_contract': '02',
    'storage_contract': '04',
    'insurance_contract': '19',
    'charter_party_contract': '05',
    'booking_contract': '06',
    'inspection_contract': '08',
    'freight_forwarding_contract': '09',
    'loading_supervision_contract': '10',
    'supervision_contract': '11',
    'guarantee_contract': '12'
  },
  trade_user_roles: {
    1: '角色1',
    2: '角色2',
    4: '角色3',
    8: '角色4',
    16: '角色5'
  },
  trade_tax_type: {
    1: '从价',
    2: '从量'
  },
  trade_goods_report_types: {
    1: '运单报告',
    2: '卸船报告',
    3: '管输报告',
    4: '商检报告',
    5: '入库单报告'
  },
  trade_charge_item_type: {
    1: '滞期费',
    2: '速遣费',
    3: '港口费',
    4: '其他'
  },
  trade_lading_bill_type: {
    1: '液体散货',
    2: '干散货',
    3: '集装箱'
  },
  trade_container_type: {
    1: '20GP',
    2: '40GP',
    3: '40HQ'
  }
}
